export default __webpack_public_path__ + "static/media/third-section-banner.5720b7db.png";